// jshint esversion: 8
import axios from 'axios';
const fetchTypes = async ({ commit, rootGetters }, querystring) => {
  let resource;
  if (process.env.VUE_APP_STAGING) {
    resource = '/busType';
  } else {
    resource = '/bus-types'
  }
  const url = process.env.VUE_APP_VEHICLES_API + resource + querystring;
  const headers = { authorization: 'Bearer '+rootGetters['auth/token'] };
  const { data } = await axios.get(url, { headers });
  commit('SET_TYPES', data);
  const typesMap = {};
  const indexByTypeMap = {};
  const ratesByTypeMap = {};
  for (let i = 0; i < data.length; i++) {
    const busType = data[i];
    typesMap[busType.id] = busType;
    indexByTypeMap[busType.id] = i;
    ratesByTypeMap[busType.id] = busType.rateSchemas;
  }
  commit('SET_TYPES_MAP', typesMap);
  commit('SET_INDEX_BY_TYPE_MAP', indexByTypeMap);
  commit('SET_RATES_BY_TYPE_MAP', ratesByTypeMap);
};

const createBusType = async ({ commit, rootGetters, getters }, payload) => {
  let resource;
  if (process.env.VUE_APP_STAGING) {
    resource = '/busType/';
  } else {
    resource = '/bus-types/'
  }
  const url = process.env.VUE_APP_VEHICLES_API + resource;
  const headers = { authorization: 'Bearer '+rootGetters['auth/token'] };
  const { data } = await axios.post(url, payload, { headers });
  commit('ADD_TYPE', data);
  commit('UPDATE_TYPES_MAP', data);
  commit(
    'UPDATE_INDEX_BY_TYPES_MAP',
    { id: data.id, value: getters.types.length - 1 }
  );
  return data
};

const updateBusType = async ({ commit, rootGetters }, payload) => {
  let resource;
  if (process.env.VUE_APP_STAGING) {
    resource = '/busType/';
  } else {
    resource = '/bus-types/'
  }
  const url = process.env.VUE_APP_VEHICLES_API + resource +payload.id +'/';
  const headers = { authorization: 'Bearer '+rootGetters['auth/token'] };
  const { data } = await axios.put(url, payload, { headers });
  commit('UPDATE_TYPE', data);
  commit('UPDATE_TYPES_MAP', data);
};

const deleteBusType = async ({ commit, rootGetters }, payload) => {
  let resource;
  if (process.env.VUE_APP_STAGING) {
    resource = '/busType/';
  } else {
    resource = '/bus-types/'
  }
  const url = process.env.VUE_APP_VEHICLES_API + resource +payload.id +'/';
  const headers = { authorization: 'Bearer '+rootGetters['auth/token'] };
  const { data } = await axios.delete(url, { headers });
  commit('DELETE_TYPE', data);
  commit('DELETE_FROM_TYPE_MAP', data);
  commit('DELETE_FROM_INDEX_MAP', data);
};

const createRate = async ({ commit, rootGetters, getters }, payload) => {
  let resource;
  if (process.env.VUE_APP_STAGING) {
    resource = '/rateSchema/';
  } else {
    resource = '/rate-schemas/'
  }
  const url = process.env.VUE_APP_VEHICLES_API +resource;
  const headers = { authorization: 'Bearer '+rootGetters['auth/token'] };
  const { data } = await axios.post(url, payload, { headers });
  const id = data.busType.id;
  const dataCopy = Object.assign({}, data);
  dataCopy.busType = id;
  let value;
  if (getters.ratesByTypeMap.hasOwnProperty(id)) {
    value = getters.ratesByTypeMap[id].slice();
    value.push(dataCopy);
  } else {
    value = [ dataCopy ];
  }
  commit('UPDATE_RATES_BY_TYPE_MAP', { id, value });
};

const updateRate = async ({ commit, rootGetters, getters }, payload) => {
  let resource;
  if (process.env.VUE_APP_STAGING) {
    resource = '/rateSchema/';
  } else {
    resource = '/rate-schemas/'
  }
  const url = process.env.VUE_APP_VEHICLES_API +resource+payload.id+'/';
  const headers = { authorization: 'Bearer '+rootGetters['auth/token'] };
  const { data } = await axios.put(url, payload, { headers });
  const id = data.busType.id;
  const dataCopy = Object.assign({}, data);
  dataCopy.busType = id;
  const value = getters.ratesByTypeMap[id].slice();
  const idx = value.findIndex(el => el.id === dataCopy.id);
  value.splice(idx, 1, dataCopy);
  commit('UPDATE_RATES_BY_TYPE_MAP', { id, value });
};

const deleteRate = async ({ commit, rootGetters, getters }, payload) => {
  let resource;
  if (process.env.VUE_APP_STAGING) {
    resource = '/rateSchema/';
  } else {
    resource = '/rate-schemas/'
  }
  const url = process.env.VUE_APP_VEHICLES_API+resource+payload.id+'/';
  const headers = { authorization: 'Bearer '+rootGetters['auth/token'] };
  const { data } = await axios.delete(url, { headers });
  const id = data.busType.id;
  const value = getters.ratesByTypeMap[id].slice();
  const idx = value.findIndex(el => el.id === data.id);
  value.splice(idx, 1);
  commit('UPDATE_RATES_BY_TYPE_MAP', { id, value });
};

export default {
  fetchTypes,
  createBusType,
  updateBusType,
  deleteBusType,
  createRate,
  updateRate,
  deleteRate
};
